import { useCallback } from "react";
import { useMessage } from "../useMessage";

export function useAuthError() {
  const message = useMessage();

  return useCallback(
    (error: any) => {
      console.error("Auth error:", error);

      let errorMessage = "Authentication failed. Please try again.";

      if (error?.data?.message) {
        errorMessage = error.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      } else if (error?.error_description) {
        // MSAL specific errors
        errorMessage = error.error_description;
      }

      message.error(errorMessage);
    },
    [message],
  );
}
